// extracted by mini-css-extract-plugin
export var contactFormSection = "ContactFormSection-module--contactFormSection--491d9";
export var contactFormSection__infoBg = "ContactFormSection-module--contactFormSection__infoBg--462f4";
export var contactFormSection__title = "ContactFormSection-module--contactFormSection__title--e3f4f";